<div
  class="single-file mb-1"
  [ngClass]="showItemBorder ? 'with-border' : ''"
  (click)="previewFile(documentInfo!.file!)"
>
  <div
    *ngIf="documentInfo?.state === documentState.Uploading"
    class="text-center"
  >
    <div class="spinner spinner-border spinner-border-sm" role="status"></div>
  </div>
  <svg-icon
    *ngIf="documentInfo?.state === documentState.Uploaded"
    class="document-icon uploaded-icon"
    src="./assets/images/icons/document.svg"
  ></svg-icon>
  <span *ngIf="documentInfo?.state !== documentState.Failed">
    {{ documentInfo?.file?.name || documentInfo?.documentName }}
  </span>

  <button
    *ngIf="documentInfo?.state !== documentState.Uploading && removable"
    type="button"
    class="btn btn-link"
    (click)="onFileRemove.emit()"
  >
    <svg-icon
      class="remove-icon"
      src="./assets/images/icons/remove.svg"
    ></svg-icon>
  </button>
</div>
